export default [
  {name: '무료', value: 'FREE'},
  {name: '조건부 무료', value: 'CONDITIONAL'},
  {name: '유료(고정 배송비)', value: 'FIXED_FEE'},
  {name: '수량비례', value: 'QUANTITY_PROPOSITIONAL_FEE'},
  {name: '중량구간별', value: 'WEIGHT_FEE'}
];
